import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  constructor() { }

  getItem<T>(key: string): T {
    let result = null;
    result = localStorage.getItem(key);
    if (result !== null) {
      result = JSON.parse(result);
    }
    return result;
  }

  setItem<T>(key: string, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeItem<T>(key: string) {
    localStorage.removeItem(key);
  }

  removeAll<T>() {
    localStorage.clear();
  }
  
  setSessionStorage<T>(key: string, value: T) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  removeSessionStorage<T>(key: string, value?: T) {
    sessionStorage.removeItem(key);
  }

  clearSessionStorage<T>() {
    sessionStorage.clear();
  }
  getItemFromSessionStorage<T>(key: string): T {
    let result = null;
    result = sessionStorage.getItem(key);
    if (result != null) {
      result = JSON.parse(result);
    }
    return result;
  }

}
